import React from "react";
import { Provider } from "react-redux";

import store from "./redux/store";
import ChatButton from "./components/chatModule/ChatButton";

function App() {
  return (
    <Provider store={store}>
      <ChatButton />
    </Provider>
  );
}

export default App;
